module.exports = __webpack_public_path__ + "static/media/Logo.cf08d1f3.png";